import { render, staticRenderFns } from "./stickyNotes.vue?vue&type=template&id=394dd75a&scoped=true&"
import script from "./stickyNotes.vue?vue&type=script&lang=js&"
export * from "./stickyNotes.vue?vue&type=script&lang=js&"
import style0 from "./stickyNotes.vue?vue&type=style&index=0&id=394dd75a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394dd75a",
  null
  
)

export default component.exports